import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold">里番动漫精选</span>
            </div>
            <p className="text-foreground-200 text-sm leading-relaxed">
              致力于为成人动漫爱好者提供最专业的里番动漫推荐与观看指南。精选优质内容，分享深度见解。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="https://weibo.com" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-50"></i>
              </a>
              <a href="https://bilibili.com" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200 cursor-pointer" aria-label="哔哩哔哩">
                <i className="ri-bilibili-line text-background-50"></i>
              </a>
              <a href="https://zhihu.com" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200 cursor-pointer" aria-label="知乎">
                <i className="ri-question-answer-line text-background-50"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-5 text-background-50">
              快速导航
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-foreground-200 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category/juqing-xiang" className="text-foreground-200 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer">分类浏览</Link>
              </li>
              <li>
                <Link to="/category/re-men-tuijian" className="text-foreground-200 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer">排行榜</Link>
              </li>
              <li>
                <Link to="/category/zuixin-fabu" className="text-foreground-200 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer">最新发布</Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-200 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-5 text-background-50">
              热门分类
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/category/juqing-xiang" className="text-foreground-200 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer">剧情向里番</Link>
              </li>
              <li>
                <Link to="/category/xiaoyuan-ticai" className="text-foreground-200 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer">校园题材</Link>
              </li>
              <li>
                <Link to="/category/qihuan-ticai" className="text-foreground-200 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer">奇幻题材</Link>
              </li>
              <li>
                <Link to="/category/jingdian-heji" className="text-foreground-200 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer">经典合集</Link>
              </li>
              <li>
                <Link to="/category/zuixin-fabu" className="text-foreground-200 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer">最新发布</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-5 text-background-50">
              联系我们
            </h4>
            <ul className="space-y-3 text-sm text-foreground-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                contact@example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400"></i>
                400-000-0000
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-400"></i>
                中国上海市浦东新区
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; {currentYear} 里番动漫精选. 保留所有权利.
          </p>
          <div className="flex items-center gap-6 text-xs text-foreground-400">
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 cursor-pointer">使用条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}